<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Colaboradores" sub="Cadastrar, alterar ou deletar colaboradores" />
        <b-form>
            <input id="colaborador-id" type="hidden" v-model="colaborador.id" />
            <b-card no-body>
                <b-tabs v-model="tabIndex" card>
                <b-tab title="Dados Básicos" active>
                    <b-card-text>
                        <div class="row">
                            <div class="col-md-8">
                                <b-form-group label="Nome:" label-for="colaborador-nome">
                                    <b-form-input id="colaborador-nome" type="text"
                                        v-model="colaborador.nome"
                                        placeholder="Informe o Nome do colaborador."
                                        :class="{ 'inputError': $v.colaborador.nome.$error }"
                                        @keydown.tab="$v.colaborador.nome.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.nome.required && $v.colaborador.nome.$error">Campo Obrigatório!</span>
                                    <span class="error" v-if="!$v.colaborador.nome.minLength && $v.colaborador.nome.$error">Precisa ter no mínimo 3 letras!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Telefone:" label-for="colaborador-telefone">
                                    <b-form-input id="colaborador-telefone" type="tel"
                                        v-model="colaborador.telefone"
                                        placeholder="Informe o telefone do colaborador."
                                        v-mask="['(##)####-####', '(##)#####-####']"
                                        :class="{ 'inputError': $v.colaborador.telefone.$error }"
                                        @keydown.tab="$v.colaborador.telefone.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.telefone.required && $v.colaborador.telefone.$error">Campo Obrigatório!</span>
                                    <span class="error" v-if="!$v.colaborador.telefone.minLength && $v.colaborador.telefone.$error">Digite um telefone válido!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8">
                                <b-form-group label="E-Mail:" label-for="colaborador-email">
                                    <b-form-input id="colaborador-email" type="email"
                                        v-model="colaborador.email"
                                        placeholder="Informe o email do colaborador."
                                        :class="{ 'inputError': $v.colaborador.email.$error }"
                                        @keydown.tab="$v.colaborador.email.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.email.required && $v.colaborador.email.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="CPF:" label-for="colaborador-cpf">
                                    <b-form-input id="colaborador-cpf" type="text"
                                        v-model="colaborador.cpf"
                                        placeholder="Informe o cpf do colaborador."
                                        v-mask="'###.###.###-##'"
                                        :class="{ 'inputError': $v.colaborador.cpf.$error }"
                                        @keydown.tab="$v.colaborador.cpf.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.cpf.required && $v.colaborador.cpf.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="CEP:" label-for="colaborador-cep">
                                    <b-form-input id="colaborador-cep" type="text"
                                        v-model="colaborador.cep"
                                        placeholder="Informe o cep do colaborador."
                                        :class="{ 'inputError': $v.colaborador.cep.$error }"
                                        v-mask="'#####-###'"
                                        @keydown.tab="searchCep"/>
                                    <span class="error" v-if="!$v.colaborador.cep.required && $v.colaborador.cep.$error">Campo Obrigatório!</span>
                                    <span class="error" v-if="!$v.colaborador.cep.minLength && $v.colaborador.cep.$error">Digite um CEP válido!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-8">
                                <b-form-group label="Endereço:" label-for="colaborador-endereco">
                                    <b-form-input id="colaborador-endereco" type="text"
                                        v-model="colaborador.endereco"
                                        placeholder="Informe o endereco do colaborador."
                                        :class="{ 'inputError': $v.colaborador.endereco.$error }"
                                        @keydown.tab="$v.colaborador.endereco.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.endereco.required && $v.colaborador.endereco.$error">Campo Obrigatório!</span>
                                    <span class="error" v-if="!$v.colaborador.endereco.minLength && $v.colaborador.endereco.$error">Precisa ter no mínimo 4 letras!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <b-form-group label="Número:" label-for="colaborador-numero">
                                    <b-form-input id="colaborador-numero" type="text"
                                        v-model="colaborador.numero"
                                        placeholder="Informe o numero do colaborador."
                                        :class="{ 'inputError': $v.colaborador.numero.$error }"
                                        @keydown.tab="$v.colaborador.numero.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.numero.required && $v.colaborador.numero.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-form-group label="Complemento:" label-for="colaborador-complemento">
                                    <b-form-input id="colaborador-complemento" type="text"
                                        v-model="colaborador.complemento"
                                        placeholder="Informe o complemento do colaborador."/>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="UF:" label-for="colaborador-uf">
                                    <b-form-select id="colaborador-uf" :options="ufs" v-model="colaborador.uf"
                                    :class="{ 'inputError': $v.colaborador.uf.$error }"
                                    @keydown.tab="$v.colaborador.uf.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.uf.required && $v.colaborador.uf.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Cidade:" label-for="colaborador-cidade">
                                    <b-form-input id="colaborador-cidade" type="text"
                                        v-model="colaborador.cidade"
                                        placeholder="Informe o cidade do colaborador."
                                        :class="{ 'inputError': $v.colaborador.cidade.$error }"
                                        @keydown.tab="$v.colaborador.cidade.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.cidade.required && $v.colaborador.cidade.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <b-button variant="outline-info" class="float-right mb-3" @click="tabIndex++">Próximo</b-button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Dados Específicos">
                    <b-card-text>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="OAB:" label-for="colaborador-oab">
                                    <b-form-input id="colaborador-oab" type="text"
                                        v-model="colaborador.oab"
                                        placeholder="Informe o oab do colaborador."
                                        :class="{ 'inputError': $v.colaborador.oab.$error }"
                                        @keydown.tab="$v.colaborador.oab.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.oab.required && $v.colaborador.oab.$error">Campo Obrigatório!</span>
                                    <span class="error" v-if="!$v.colaborador.oab.minLength && $v.colaborador.oab.$error">Precisa ter no mínimo 4 dígitos!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Estado OAB:" label-for="colaborador-estado">
                                    <b-form-input id="colaborador-estado" type="text"
                                        v-model="colaborador.estado"
                                        placeholder="Informe o estado do colaborador."
                                        :class="{ 'inputError': $v.colaborador.estado.$error }"
                                        @keydown.tab="$v.colaborador.estado.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.estado.required && $v.colaborador.estado.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Nível:" label-for="colaborador-nivel">
                                    <b-form-select id="colaborador-nivel" :options="nivels" v-model="colaborador.nivel"
                                    :class="{ 'inputError': $v.colaborador.nivel.$error }"
                                    @keydown.tab="$v.colaborador.nivel.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.nivel.required && $v.colaborador.nivel.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Ativo:" label-for="colaborador-ativo">
                                    <b-form-select id="colaborador-ativo" :options="ativos" v-model="colaborador.ativo"
                                    :class="{ 'inputError': $v.colaborador.ativo.$error }"
                                    @keydown.tab="$v.colaborador.ativo.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.ativo.required && $v.colaborador.ativo.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <b-button variant="outline-info" class="float-right mb-3" @click="tabIndex++">Próximo</b-button>
                    </b-card-text>
                </b-tab>
                <b-tab title="Dados Bancários">
                    <b-card-text>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Banco:" label-for="colaborador-banco">
                                    <b-form-select id="colaborador-banco" :options="bancos" v-model="colaborador.banco"
                                    :class="{ 'inputError': $v.colaborador.banco.$error }"
                                    @keydown.tab="$v.colaborador.banco.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.banco.required && $v.colaborador.banco.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Tipo de Conta:" label-for="colaborador-tipo_conta">
                                    <b-form-select id="colaborador-tipo_conta" :options="tipo_contas" v-model="colaborador.tipo_conta"
                                    :class="{ 'inputError': $v.colaborador.tipo_conta.$error }"
                                    @keydown.tab="$v.colaborador.tipo_conta.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.tipo_conta.required && $v.colaborador.tipo_conta.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="Agência:" label-for="colaborador-agencia">
                                    <b-form-input id="colaborador-agencia" type="text"
                                        v-model="colaborador.agencia"
                                        placeholder="Informe o agencia do colaborador."
                                        :class="{ 'inputError': $v.colaborador.agencia.$error }"
                                        @keydown.tab="$v.colaborador.agencia.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.agencia.required && $v.colaborador.agencia.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-form-group label="Dígito:" label-for="colaborador-ag_dv">
                                    <b-form-input id="colaborador-ag_dv" type="text"
                                        v-model="colaborador.ag_dv"
                                        placeholder="Informe o ag_dv do colaborador."
                                        :class="{ 'inputError': $v.colaborador.ag_dv.$error }"
                                        @keydown.tab="$v.colaborador.ag_dv.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.ag_dv.required && $v.colaborador.ag_dv.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Conta:" label-for="colaborador-conta">
                                    <b-form-input id="colaborador-conta" type="text"
                                        v-model="colaborador.conta"
                                        placeholder="Informe o conta do colaborador."
                                        :class="{ 'inputError': $v.colaborador.conta.$error }"
                                        @keydown.tab="$v.colaborador.conta.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.conta.required && $v.colaborador.conta.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-form-group label="Dígito:" label-for="colaborador-conta_dv">
                                    <b-form-input id="colaborador-conta_dv" type="text"
                                        v-model="colaborador.conta_dv"
                                        placeholder="Informe o conta_dv do colaborador."
                                        :class="{ 'inputError': $v.colaborador.conta_dv.$error }"
                                        @keydown.tab="$v.colaborador.conta_dv.$touch"/>
                                    <span class="error" v-if="!$v.colaborador.conta_dv.required && $v.colaborador.conta_dv.$error">Campo Obrigatório!</span>
                                </b-form-group>
                            </div>
                        </div>
                        <b-button variant="outline-danger" class="float-right ml-2 mb-3" @click="reset">Cancelar</b-button>
                        <b-button variant="outline-success" class="float-right mb-3" @click="save">Salvar</b-button>
                    </b-card-text>
                </b-tab>
                </b-tabs>
            </b-card>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-colaboradores" 
                class="text-center table table-sm" 
                :items="colaboradores" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadColaborador(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-colaboradores"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-colaboradores" 
                class="text-center table table-sm" 
                :items="colaboradores" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadColaborador(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-colaboradores"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'colaboradores',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            tabIndex: 0,
            jwt: new VueEasyJwt(),
            tipo_contas: [
                { value: 'conta_corrente', text: 'Conta Corrente' },
                { value: 'conta_poupanca', text: 'Conta Poupança' }
            ],
            bancos: [
                { value : '001', text : 'Banco do Brasil' },
                { value : '003', text : 'Banco da Amazônia' },
                { value : '004', text : 'Banco do Nordeste' },
                { value : '021', text : 'Banestes' },
                { value : '025', text : 'Banco Alfa' },
                { value : '027', text : 'Besc' },
                { value : '029', text : 'Banerj' },
                { value : '031', text : 'Banco Beg' },
                { value : '033', text : 'Banco Santander Banespa' },
                { value : '036', text : 'Banco Bem' },
                { value : '037', text : 'Banpará' },
                { value : '038', text : 'Banestado' },
                { value : '039', text : 'BEP' },
                { value : '040', text : 'Banco Cargill' },
                { value : '041', text : 'Banrisul' },
                { value : '044', text : 'BVA' },
                { value : '045', text : 'Banco Opportunity' },
                { value : '047', text : 'Banese' },
                { value : '062', text : 'Hipercard' },
                { value : '063', text : 'Ibibank' },
                { value : '065', text : 'Lemon Bank' },
                { value : '066', text : 'Banco Morgan Stanley Dean Witter' },
                { value : '069', text : 'BPN Brasil' },
                { value : '070', text : 'Banco de Brasília – BRB' },
                { value : '072', text : 'Banco Rural' },
                { value : '073', text : 'Banco Popular' },
                { value : '074', text : 'Banco J. Safra' },
                { value : '075', text : 'Banco CR2' },
                { value : '076', text : 'Banco KDB' },
                { value : '096', text : 'Banco BMF' },
                { value : '104', text : 'Caixa Econômica Federal' },
                { value : '107', text : 'Banco BBM' },
                { value : '116', text : 'Banco Único' },
                { value : '151', text : 'Nossa Caixa' },
                { value : '175', text : 'Banco Finasa' },
                { value : '184', text : 'Banco Itaú BBA' },
                { value : '204', text : 'American Express Bank' },
                { value : '208', text : 'Banco Pactual' },
                { value : '212', text : 'Banco Matone' },
                { value : '213', text : 'Banco Arbi' },
                { value : '214', text : 'Banco Dibens' },
                { value : '217', text : 'Banco Joh Deere' },
                { value : '218', text : 'Banco Bonsucesso' },
                { value : '222', text : 'Banco Calyon Brasil' },
                { value : '224', text : 'Banco Fibra' },
                { value : '225', text : 'Banco Brascan' },
                { value : '229', text : 'Banco Cruzeiro' },
                { value : '230', text : 'Unicard' },
                { value : '233', text : 'Banco GE Capital' },
                { value : '237', text : 'Bradesco' },
                { value : '241', text : 'Banco Clássico' },
                { value : '243', text : 'Banco Stock Máxima' },
                { value : '246', text : 'Banco ABC Brasil' },
                { value : '248', text : 'Banco Boavista Interatlântico' },
                { value : '249', text : 'Investcred Unibanco' },
                { value : '250', text : 'Banco Schahin' },
                { value : '252', text : 'Fininvest' },
                { value : '254', text : 'Paraná Banco' },
                { value : '263', text : 'Banco Cacique' },
                { value : '265', text : 'Banco Fator' },
                { value : '266', text : 'Banco Cédula' },
                { value : '300', text : 'Banco de la Nación Argentina' },
                { value : '318', text : 'Banco BMG' },
                { value : '320', text : 'Banco Industrial e Comercial' },
                { value : '356', text : 'ABN Amro Real' },
                { value : '341', text : 'Itau' },
                { value : '347', text : 'Sudameris' },
                { value : '351', text : 'Banco Santander' },
                { value : '353', text : 'Banco Santander Brasil' },
                { value : '366', text : 'Banco Societe Generale Brasil' },
                { value : '370', text : 'Banco WestLB' },
                { value : '376', text : 'JP Morgan' },
                { value : '389', text : 'Banco Mercantil do Brasil' },
                { value : '394', text : 'Banco Mercantil de Crédito' },
                { value : '399', text : 'HSBC' },
                { value : '409', text : 'Unibanco' },
                { value : '412', text : 'Banco Capital' },
                { value : '422', text : 'Banco Safra' },
                { value : '453', text : 'Banco Rural' },
                { value : '456', text : 'Banco Tokyo Mitsubishi UFJ' },
                { value : '464', text : 'Banco Sumitomo Mitsui Brasileiro' },
                { value : '477', text : 'Citibank' },
                { value : '479', text : 'Itaubank { antigo Bank Boston },' },
                { value : '487', text : 'Deutsche Bank' },
                { value : '488', text : 'Banco Morgan Guaranty' },
                { value : '492', text : 'Banco NMB Postbank' },
                { value : '494', text : 'Banco la República Oriental del Uruguay' },
                { value : '495', text : 'Banco La Provincia de Buenos Aires' },
                { value : '505', text : 'Banco Credit Suisse' },
                { value : '600', text : 'Banco Luso Brasileiro' },
                { value : '604', text : 'Banco Industrial' },
                { value : '610', text : 'Banco VR' },
                { value : '611', text : 'Banco Paulista' },
                { value : '612', text : 'Banco Guanabara' },
                { value : '613', text : 'Banco Pecunia' },
                { value : '623', text : 'Banco Panamericano' },
                { value : '626', text : 'Banco Ficsa' },
                { value : '630', text : 'Banco Intercap' },
                { value : '633', text : 'Banco Rendimento' },
                { value : '634', text : 'Banco Triângulo' },
                { value : '637', text : 'Banco Sofisa' },
                { value : '638', text : 'Banco Prosper' },
                { value : '643', text : 'Banco Pine' },
                { value : '652', text : 'Itaú Holding Financeira' },
                { value : '653', text : 'Banco Indusval' },
                { value : '654', text : 'Banco A.J. Renner' },
                { value : '655', text : 'Banco Votorantim' },
                { value : '707', text : 'Banco Daycoval' },
                { value : '719', text : 'Banif' },
                { value : '721', text : 'Banco Credibel' },
                { value : '734', text : 'Banco Gerdau' },
                { value : '735', text : 'Banco Pottencial' },
                { value : '738', text : 'Banco Morada' },
                { value : '739', text : 'Banco Galvão de Negócios' },
                { value : '740', text : 'Banco Barclays' },
                { value : '741', text : 'BRP' },
                { value : '743', text : 'Banco Semear' },
                { value : '745', text : 'Banco Citibank' },
                { value : '746', text : 'Banco Modal' },
                { value : '747', text : 'Banco Rabobank International' },
                { value : '748', text : 'Banco Cooperativo Sicredi' },
                { value : '749', text : 'Banco Simples' },
                { value : '751', text : 'Dresdner Bank' },
                { value : '752', text : 'BNP Paribas' },
                { value : '753', text : 'Banco Comercial Uruguai' },
                { value : '755', text : 'Banco Merrill Lynch' },
                { value : '756', text : 'Banco Cooperativo do Brasil' },
                { value : '757', text : 'KEB' }
            ],
            nivels: [
                { value: '1', text: 'Fornecedor' },
                { value: '2', text: 'Prestador' },
                { value: '3', text: 'Ambos' }
            ],
            ativos: [
                { value: '1', text: 'Sim' },
                { value: '0', text: 'Não' }
            ],
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            colaborador: {},
            colaboradores: [],
            fields: [
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'telefone', label: 'Telefone', sortable: true },
                { key: 'email', label: 'E-mail', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        ...mapState([ 'user' ]),
        rows() {
            return this.colaboradores.length
        }
    },
    validations: {
        colaborador: {
            nome: {
                required,
                minLength: minLength(4)
            },
            telefone: {
                required,
                minLength: minLength(10)
            },
            email: {
                required,
                email
            },
            cpf: {
                required
            },
            cep: {
                required,
                minLength: minLength(8)
            },
            endereco: {
                required,
                minLength: minLength(4)
            },
            numero: {
                required
            },
            cidade: {
                required
            },
            uf: {
                required
            },
            oab: {
                required,
                minLength: minLength(4)
            },
            estado: {
                required
            },
            nivel: {
                required
            },
            ativo: {
                required
            },
            banco: {
                required
            },
            agencia: {
                required
            },
            ag_dv: {
                required
            },
            conta: {
                required
            },
            conta_dv: {
                required
            },
            tipo_conta: {
                required
            }
            
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        searchCep () {
            this.$v.colaborador.cep.$touch()
			if(this.colaborador.cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.colaborador.cep }/json/`)
                .then( res => {
                    this.colaborador.cidade = res.data.localidade
                    this.colaborador.endereco = res.data.logradouro
                    this.colaborador.uf = res.data.uf
                    document.getElementById("colaborador-endereco").value = res.data.logradouro
                    document.getElementById("colaborador-uf").value = res.data.uf
                    document.getElementById("colaborador-cidade").value = res.data.localidade
                    document.getElementById("colaborador-numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("colaborador-endereco").value = ''
                document.getElementById("colaborador-uf").value = ''
                document.getElementById("colaborador-cidade").value = ''
            }
        },
        loadColaboradores() {
            const url = `${baseApiUrl}/backend/SELECT/colaboradores.php`
            axios.get(url).then(res => {
                this.colaboradores = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.colaborador = {}
            this.loadColaboradores()
            this.colaborador.cidade = ''
            this.colaborador.endereco = ''
            this.colaborador.uf = ''
            document.getElementById("colaborador-endereco").value = ''
            document.getElementById("colaborador-uf").value = ''
            document.getElementById("colaborador-cidade").value = ''
            this.$v.colaborador.$reset()
        },
        save() {
            this.$v.colaborador.$touch()
            if(!this.$v.colaborador.$error){
                const method = this.colaborador.id ? 'put' : 'post'
                this.colaborador.senha = '1234'
                this.colaborador.cliente_id = '1234'
                this.colaborador.recebedor_id = '1234'
                const id = this.colaborador.id ? `?id=${this.colaborador.id}` : ''
                if(method === 'post'){
                    axios[method](`${baseApiUrl}/backend/INSERT/colaboradores.php`, this.colaborador)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Colaborador inserido com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                } else {
                    axios[method](`${baseApiUrl}/backend/UPDATE/colaboradores.php${id}`, this.colaborador)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Colaborador alterado com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(colaborador) {
            const sure = confirm("Deseja realmente excluir o Colaborador?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/DELETE/colaboradores.php`
                axios.delete(url, { data: colaborador })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Colaborador excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadColaborador(colaborador) {
            this.colaborador = { ...colaborador }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
        this.loadColaboradores()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.colaboradores.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

#colaborador-nome, #colaborador-telefone, #colaborador-email, #colaborador-senha, #colaborador-cep, 
#colaborador-endereco, #colaborador-numero, #colaborador-complemento, #colaborador-cidade, #colaborador-uf, 
#colaborador-oab, #colaborador-estado, #colaborador-nivel, #colaborador-ativo, #colaborador-banco, 
#colaborador-tipo_conta, #colaborador-agencia, #colaborador-ag_dv, #colaborador-conta, #colaborador-conta_dv,
#colaborador-cpf {
   /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border-bottom: 1px solid #f57f6c !important;
}

.text-custom {
    font-size: 0.8rem;
}
</style>